import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import catalogosModule from "./catalogos";
import listaPreciosModule from "./catalogos/listaprecios";
import cotizacionesComprasModule from "./compras/cotizaciones";
import reqcomprasModule from "./compras/reqcompras";
import ordencomprasModule from "./compras/ordencompra";
import reqtrasladoModule from "./inventario/reqtraslado";
import salidasTrasladoModule from "./inventario/salidatraslado";
import entradasTrasladoModule from "./inventario/entradatraslado";
import envioInventarioModule from "./inventario/envioinventario";
import ajusteInventarioModule from "./inventario/ajusteinventario";
import entradasComprasModule from "./inventario/entradacompra";
import devolucionProveedores from "./inventario/devolucion_proveedores";
import cargosModule from "./cxc/cargos";
import abonosModule from "./cxc/abonos";
import cxpcargosModule from "./cxp/cargos";
import cxpabonosModule from "./cxp/abonos";
import recepcionesModule from "./wms/recepciones";
import accountsModule from "./accounts";
import contaModule from "./conta";
import bancosModule from "./bancos";
import activosfijosModul from "./af";
import buzonSugerenciasModule from "./rrhh/buzonsugerencias";
import permisosModule from "./permisos";
import commonsModule from "./commons";

Vue.use(Vuex);

let catalogos = catalogosModule;

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['recepciones.selectedInvoice', 'recepciones.receiptType']
    })
  ],
  modules: {
    devolucionproveedores: devolucionProveedores,
    commons: commonsModule,
    catalogos: catalogosModule,
    listaprecios: listaPreciosModule,
    reqcompras: reqcomprasModule,
    cotizaciones: cotizacionesComprasModule,
    reqtraslado: reqtrasladoModule,
    ordencompra: ordencomprasModule,
    salidastraslados: salidasTrasladoModule,
    entradastraslados: entradasTrasladoModule,
    enviosinventario: envioInventarioModule,
    ajusteinventario: ajusteInventarioModule,
    entradascompras: entradasComprasModule,
    cargos: cargosModule,
    abonos: abonosModule,
    cxpcargos: cxpcargosModule,
    cxpabonos: cxpabonosModule,
    recepciones: recepcionesModule,
    accounts: accountsModule,
    conta: contaModule,
    bancos: bancosModule,
    af: activosfijosModul,
    buzon_sugerencias: buzonSugerenciasModule,
    permisos: permisosModule,
  },
  state: {
    layout: "app-layout",
    module: "dashboard",
    modules: [
      {
        name: "catalogos",
        description: "Catálogos",
        icon: "fas fa-book",
        show_in_hh: true,
        items: [
          {
            name: "Bancos",
            description: "Bancos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/bancos/",
            permiso: "view_banco",
          },
          {
            name: "posiciones por tienda",
            description: "Posiciones para Tiendas",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/tienda-bodega/",
            permiso: "view_tiendabodega",
          },
          {
            name: "Campañas",
            description: "Campañas de Ofertas",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/escalas/",
            permiso: "",
          },
          {
            name: "categorias",
            description: "Categorías",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/categorias/",
            permiso: "view_categoria",
          },
          {
            name: "centro de costos",
            description: "Centro de Costos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/centro-costos/",
            permiso: "view_centrocosto",
          },
          {
            name: "clientes",
            description: "Clientes",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/clientes",
            permiso: "view_cliente",
          },
          {
            name: "consulta de producto",
            description: "Consulta de Productos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/consulta-productos/",
            permiso: null,
          },
          {
            name: "Cuentas Bancarias",
            description: "Cuentas Bancarias",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/cuentas-bancarias/",
            permiso: "view_cuentabancaria",
          },
          {
            name: "cuponera",
            description: "Cuponera",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/pos/cuponera/",
            permiso: null,
          },
          {
            name: "Formas Pago",
            description: "Formas de Pago",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/formas-pago/",
            permiso: "view_formapago",
          },
          {
            name: "impresion de promociones",
            description: "Impresión de Ofertas y Promociones",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/ofertas-promociones/",
            permiso: null,
          },
          {
            name: "lista-precios",
            description: "Lista Precios",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/lista_precios",
            permiso: "view_listaprecio",
          },
          {
            name: "posiciones",
            description: "Posiciones",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/posiciones/",
            permiso: "view_tiendaposicion",
          },
          {
            name: "Preciadores Miniso",
            description: "Preciadores Miniso",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/reportes/minisoprecios/",
            permiso: null,
          },
          {
            name: "productos",
            description: "Productos",
            icon: "fas fa-box",
            show_in_hh: true,
            to: "/cat/productos/",
            permiso: "view_producto",
          },
          {
            name: "ProductoTienda",
            description: "Producto-Tienda",
            icon: "fas fa-char-area",
            show_in_hh: false,
            to: "/cat/producto-tienda/gestion-producto-tienda/",
            permiso: "view_producto",
          },
          {
            name: "proveedores",
            description: "Proveedores",
            icon: "fas fa-users",
            show_in_hh: true,
            to: "/cat/proveedores",
            permiso: "view_proveedor",
          },
          {
            name: "superclientes",
            description: "Super Clientes",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/superclientes",
            permiso: "view_cliente",
          },
          {
            name: "tiendas",
            description: "Tiendas",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/tiendas/",
            permiso: "view_tienda",
          },
          {
            name: "unidades-medidas",
            description: "Unidades de Medidas",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/unidades-medidas/",
            permiso: "view_unidadmedida",
          },
          {
            name: "recetas",
            description: "Recetas",
            icon: "fas fa-list",
            show_in_hh: true,
            to: "/cat/recetas/",
            permiso: null,
          },
          {
            name: "terminales-pos",
            description: "Terminales POS",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/terminales-pos/",
            permiso: null,
          }
        ],
      },
      {
        name: "compras",
        description: "Compras",
        icon: "fas fa-shopping-cart",
        show_in_hh: false,
        items: [
          {
            name: "cotizaciones",
            description: "Cotizaciones",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/compras/cotizaciones/",
            permiso: null,
          },
          {
            name: "lista-precios",
            description: "Lista Precios",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/lista_precios",
            permiso: null,
          },
          {
            name: "ordencompra",
            description: "Orden Compra",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/compras/ordencompra/",
            permiso: null,
          },
          {
            name: "compras-lista-precios-compras",
            description: "Precios de Compra / Costos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/compras/lista-precios-compras/",
            permiso: "view_vwproductocosto",
          },
          {
            name: "req-compra",
            description: "Requerimientos de Compra",
            icon: "os-icon os-icon-layout",
            show_in_hh: true,
            to: "/compras/req-compra/",
            permiso: null,
          },
        ],
      },
      {
        name: "pos",
        description: "POS",
        icon: "fas fa-cash-register",
        show_in_hh: true,
        items: [
          {
            name: "Corte",
            description: "Corte de Caja",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/corte-caja/",
            permiso: null,
          },
          {
            name: "Corte de Tienda",
            description: "Corte de Tienda",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/corte-tienda/",
            permiso: null,
          },
          // {
          //   name: "Corte de Tienda Mayoreo",
          //   description: "Corte de Tienda Mayoreo",
          //   icon: "os-icon os-icon-layout",
          //   show_in_hh: false,
          //   to: "/cxc/corte-tienda-mayoreo/",
          //   permiso: null,
          // },
          // {
          //   name: "Corte de Tienda 2",
          //   description: "Corte de Tienda 2",
          //   icon: "os-icon os-icon-layout",
          //   show_in_hh: false,
          //   to: "/cxc/corte-tienda2/",
          //   permiso: null,
          // },
          {
            name: "Corte Diario de Tienda",
            description: "Corte Diario de Tienda",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/reportes/corte-tienda-global/",
            permiso: null,
          },
          {
            name: "cotizciones_a_clientes",
            description: "Cotizaciones a Clientes",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/pos/cotizaciones/",
            permiso: null,
          },
          {
            name: "cotizacion_movil",
            description: "Cotización Factura (Escaneo)",
            // Nombre en el menu movil (en escritorio se distingue de "Cotizaciones a Clientes")
            description_hh: "Cotización Factura",
            icon: "fa fa-barcode",
            show_in_hh: true,
            to: "/pos/cotizacion-movil/?tipo=factura",
            permiso: null,
          },
          {
            name: "Caja",
            description: "Lista de Cajas",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/caja",
            permiso: 'cxccaja.view_cxccaja',
          },
          {
            name: "Pedidos",
            description: "Pedidos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/pos/pedidos/",
            permiso: null,
          },
          {
            name: "pedidos mayo",
            description: "Pedidos Mayoreo",
            icon: "os-icon os-icon-layout",
            show_in_hh: true,
            to: "/pos/pedidos-mayoreo/",
            permiso: null,
          },
          // {
          //   name: "pos_hotel",
          //   description: "POS Hotel",
          //   icon: "os-icon os-icon-layout",
          //   show_in_hh: false,
          //   to: "/pos/venta/",
          //   permiso: null,
          // },
        ],
      },
      {
        name: "cxc",
        description: "CXC",
        icon: "fas fa-receipt",
        show_in_hh: false,
        items: [
          /*{
                        name: 'Tipo Cargo',
                        description: 'Tipos de Cargos',
                        icon: 'os-icon os-icon-layout',
                        to: '/cxc/tipo-cargo/',
                        permiso: null,
                    }, {
                        name: 'Tipo Abono',
                        description: 'Tipos de Abono',
                        icon: 'os-icon os-icon-layout',
                        to: '/cxc/tipo-abono',
                        permiso: null,
                    }, {
                        name: 'Serie Cargo',
                        description: 'Series de Cargos',
                        icon: 'os-icon os-icon-layout',
                        to: '/cxc/cargo-serie/',
                        permiso: null,
                    }, {
                        name: 'Serie Abono',
                        description: 'Series de Abonos',
                        icon: 'os-icon os-icon-layout',
                        to: '/cxc/abono-serie/',
                        permiso: null,
                    }, */
          {
            name: "abonos",
            description: "Abonos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/abonos",
            permiso: null,
          },
          {
            name: "abonos-fel",
            description: "Abonos Sin Subir a FEL",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/abonos-fel",
            permiso: null,
          },
          {
            name: "cargos",
            description: "Cargos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/cargos",
            permiso: null,
          },
          {
            name: "cargos-fel",
            description: "Cargos Sin Subir a FEL",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/cargos-fel",
            permiso: null,
          },
          {
            name: "cobros",
            description: "Cobros",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/cobros",
            permiso: null,
          },
          {
            name: "cuentas-clientes",
            description: "Estado de Cuenta de Clientes",
            icon: "fas fa-file-signature",
            show_in_hh: false,
            to: "/cxc/reporte-cuentas/",
            permiso: null,
          },
          // {
          //   name: "estados-cuentas",
          //   description: "Estados de Cuenta",
          //   icon: "fas fa-file-signature",
          //   show_in_hh: false,
          //   to: "/cxc/estados-cuentas/",
          //   permiso: null,
          // },
          {
            name: "linea_credito",
            description: "Linea Crédito",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/linea_credito",
            permiso: null,
          },
          {
            name: "reclamo_cliente",
            description: "Reclamo Cliente",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxc/reclamo_cliente",
            permiso: null,
          },
        ],
      },
      {
        name: "cuentas por pagar",
        description: "CXP",
        icon: "fas fa-file-invoice-dollar",
        show_in_hh: false,
        items: [
          {
            name: "abonos",
            description: "Abonos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxp/abono/",
            permiso: null,
          },
          {
            name: "cargos",
            description: "Cargos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxp/cargo/",
            permiso: null,
          },
          {
            name: "estado cuenta proveedor",
            description: "Estado Cuenta Proveedor",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxp/estado-cuenta-proveedor/",
            permiso: null,
          },
          {
            name: "serie abono",
            description: "Series de Abonos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxp/abono-serie/",
            permiso: null,
          },
          {
            name: "tipo abono",
            description: "Tipos de Abonos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxp/tipo-abono/",
            permiso: null,
          },
          {
            name: "tipo cargo",
            description: "Tipos de Cargos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cxp/tipo-cargo/",
            permiso: null,
          },
        ],
      },
      {
        name: "inv",
        description: "Inventario",
        icon: "fas fa-boxes",
        show_in_hh: true,
        items: [
          {
            name: "ajuste_inventario",
            description: "Ajuste de Inventario",
            icon: "fas fa-wrench",
            show_in_hh: false,
            to: "/inventario/ajuste_inventario/",
            permiso: null,
          },
          {
            name: "conteo_agrupado",
            description: "Conteo Agrupado",
            icon: "fas fa-list-alt",
            show_in_hh: true,
            to: "/inventario/conteo-agrupado/",
            permiso: null,
          },
          {
            name: "conteo-productoa",
            description: "Conteo de Inventario",
            icon: "fas fa-list-alt",
            show_in_hh: true,
            to: "/inventario/conteo/",
            permiso: null,
          },
          {
            name: "conversiones",
            description: "Conversiones",
            icon: "fa fa-times",
            show_in_hh: false,
            to: "/inventario/conversiones/",
            permiso: null,
          },
          {
            name: "devoluciones a clientes",
            description: "Devoluciones a Clientes",
            icon: "fa fa-file-invoice",
            show_in_hh: false,
            to: "/inventario/devoluciones",
            permiso: null,
          },
          // SECCION YA NO SE UTILIZA, SE USA DE WMS
          // {
          //   name: "devoluciones a Proveedores",
          //   description: "Devoluciones a Proveedores",
          //   icon: "fas fa-briefcase",
          //   show_in_hh: false,
          //   to: "/inventario/devolucion_proveedor/",
          //   permiso: null,
          // },
          {
            name: "entrada_compra",
            description: "Entrada por Compra",
            icon: "fas fa-people-carry",
            show_in_hh: false,
            to: "/inventario/entrada_compra/",
            permiso: null,
          },
          {
            name: "entrada_traslado",
            description: "Entrada por Traslado",
            icon: "fas fa-boxes",
            show_in_hh: true,
            to: "/inventario/entrada_traslado/",
            permiso: null,
          },
          {
            name: "envio_inventario",
            description: "Envio de Inventario",
            icon: "fa fa-share",
            show_in_hh: true,
            to: "/inventario/envio_inventario/",
            permiso: null,
          },
          {
            name: "kardex",
            description: "Kardex",
            icon: "fas fa-chart-line",
            show_in_hh: true,
            to: "/inventario/reportes/kardex/",
            permiso: null,
          },
          {
            name: "Liquidacion_producto",
            description: "Liquidación de Productos",
            icon: "fa fa-times",
            show_in_hh: false,
            to: "/inventario/liquidacion-producto/",
            permiso: null,
          },
          {
            name: "productos",
            description: "Productos",
            icon: "fas fa-box",
            show_in_hh: true,
            to: "/cat/productos/",
            permiso: "view_producto",
          },
          {
            name: "pendiente_pedir",
            description: "Productos Pendientes de Pedir",
            icon: "fas fa-edit",
            show_in_hh: true,
            to: "/inventario/pendiente_pedir/",
            permiso: null,
          },
          {
            name: "req_traslado",
            description: "Req Traslado",
            icon: "fas fa-file-export",
            show_in_hh: true,
            to: "/inventario/req_traslado/",
            permiso: null,
          },
          {
            name: "cotizaciones_requerimiento",
            description: "Cotizaciones de Requerimiento",
            icon: "fas fa-file-invoice",
            show_in_hh: false,
            to: "/inventario/cotizaciones-requerimiento/",
            permiso: null,
          },
          {
            name: "cotizacion_movil_requerimiento",
            description: "Cotización Requerimiento (Escaneo)",
            // Nombre en el menu movil (en escritorio se distingue de "Cotizaciones de Requerimiento")
            description_hh: "Cotización Requerimiento",
            icon: "fa fa-barcode",
            show_in_hh: true,
            to: "/pos/cotizacion-movil/?tipo=requerimiento",
            permiso: null,
          },
          {
            name: "req_traslado_loc",
            description: "Req Traslado Localización",
            icon: "fas fa-clipboard-list",
            show_in_hh: true,
            to: "/inventario/req_traslado_loc/",
            permiso: null,
          },
          {
            name: "req_pendientes",
            description: "Reqs Pend. de Traslados",
            icon: "fas fa-clock",
            show_in_hh: true,
            to: "/inventario/requisiciones-abiertas/",
            permiso: null,
          },
          {
            name: "revision-piso",
            description: "Revisión Piso",
            icon: "fa fa-search",
            show_in_hh: true,
            to: "/inventario/reportes/revision-piso/",
            permiso: null,
          },
          {
            name: "salida_inventario",
            description: "Salida de inventario  ",
            icon: "fas fa-box-open",
            show_in_hh: true,
            to: "/inventario/salida_inventario/",
            permiso: null,
          },
          {
            name: "salida_traslado",
            description: "Salidas por Traslado",
            icon: "fas fa-dolly-flatbed",
            show_in_hh: true,
            to: "/inventario/salida_traslado/",
            permiso: null,
          },
          {
            name: "traslados_loc",
            description: "Traslados de localización directa",
            icon: "fas fa-route",
            show_in_hh: true,
            to: "/inventario/traslados_loc/",
            permiso: null,
          },
          // {
          //     name: 'tarimas_devolucion_traslados',
          //     description: 'Tarimas de Devoluciones',
          //     icon: 'fa fa-times',
          //     to: '/inventario/tarima_devoluciones/',
          //     permiso: null,
          // },
        ],
      },
      {
        name: "wms",
        description: "WMS",
        icon: "fas fa-dolly",
        show_in_hh: true,
        items: [
          {
            name: "agenda",
            description: "Agenda de Proveedores",
            icon: "far fa-calendar-alt",
            show_in_hh: true,
            to: "/wms/agenda/",
            permiso: null,
          },
          {
            name: "wms-asignar-pedido-reparto",
            description: "Asignar Pedido a Reparto",
            icon: "fas fa-truck",
            show_in_hh: true,
            to: "/wms/asignar-pedido-reparto/",
            permiso: null,
          },
          {
            name: "contenedor",
            description: "Contenedores",
            icon: "fas fa-truck-moving",
            show_in_hh: true,
            to: "/wms/contenedor/",
            permiso: null,
          },
          {
            name: "dashboard-posiciones",
            description: "Dashboard Posiciones",
            icon: "fas fa-bars",
            show_in_hh: true,
            to: "/wms/dashboard/posiciones/",
            permiso: null,
          },
          {
            name: "wms-envio_despacho",
            description: "Despacho Mayoreo",
            icon: "fas fa-clipboard-list",
            show_in_hh: true,
            to: "/wms/envio-despachos/",
            permiso: null,
          },
          {
            name: "wms-devolucion-mayoreo",
            description: "Devoluciones Mayoreo",
            icon: "fas fa-exchange-alt",
            show_in_hh: true,
            to: "/wms/devolucion-mayoreo/",
            permiso: null,
          },
          {
            name: "devoluciones_clientes",
            description: "Devoluciones a clientes",
            icon: "fa fa-file-invoice",
            show_in_hh: true,
            to: "/wms/devoluciones/",
            permiso: null,
          },
          {
            name: "Devoluciones_proveedores",
            description: "Devoluciones a Proveedores",
            icon: "fas fa-briefcase",
            show_in_hh: true,
            to: "/wms/devolucion-provedor/",
            permiso: null,
          },
          {
            name: "devoluciones_productos",
            description: "Tarimas por Devolución Tiendas a CEDIS",
            icon: "fas fa-file",
            show_in_hh: true,
            to: "/wms/devolucion-tarima/",
            permiso: null,
          },
          {
            name: "movimiento_localizacion",
            description: "Picking entre Localizaciones",
            icon: "fas fa-dolly",
            show_in_hh: true,
            to: "/wms/movimiento-localizacion/",
            permiso: null,
          },
          {
            name: "wms-picking_despacho",
            description: "Picking Mayoreo",
            icon: "fas fa-clipboard-check",
            show_in_hh: true,
            to: "/wms/despachos/",
            permiso: null,
          },
          {
            name: "recepcion",
            description: "Recepción",
            icon: "fas fa-check-circle",
            show_in_hh: true,
            to: "/wms/recepcion/",
            permiso: null,
          },
          {
            name: "recepcion-contenedor-buscar",
            description: "Recepcion Contenedor",
            icon: "fas fa-truck-loading",
            show_in_hh: true,
            to: "/wms/recepcion-contenedor/buscar/",
            permiso: null,
          },
          {
            name: "devolucion_recepcion_prov",
            description: "Recepción devolucion proveedor",
            icon: "fas fa-file-alt",
            show_in_hh: true,
            to: "/inventario/recepcion_devolucion/",
            permiso: null,
          },
          {
            name: "recepcion-tarima-buscar",
            description: "Recepción Tarima",
            icon: "far fa-check-square",
            show_in_hh: true,
            to: "/wms/recepcion-tarima/buscar/",
            permiso: null,
          },
          {
            name: "tareas",
            description: "Tareas",
            icon: "fa fa-tasks",
            show_in_hh: true,
            to: "/wms/tareas/",
            permiso: null,
          },
          {
            name: "tarimas",
            description: "Tarimas por Traslado CEDIS a Tiendas",
            icon: "fa fa-pallet",
            show_in_hh: true,
            to: "/wms/tarimas/",
            permiso: null,
          },
          {
            name: "inconsistencias_tarimas",
            description: "Inconsistencias Tarimas",
            icon: "fas fa-exclamation-triangle",
            show_in_hh: false,
            to: "/wms/inconsistencias-tarima/",
            permiso: null,
          },
          {
            name: "transferencia_stock",
            description: "Transferencia de Stock",
            icon: "fas fa-boxes",
            show_in_hh: true,
            to: "/wms/transferencia-stock/",
            permiso: null,
          },
        ],
      },
      {
        name: "talleres",
        description: "Talleres",
        icon: "fas fa-car",
        show_in_hh: false,
        items: [
          {
            name: "talleres-ordenes",
            description: "Ordenes",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/talleres/inicio",
            permiso: null,
          },
        ],
      },
      {
        name: "bancos",
        description: "Bancos",
        icon: "fas fa-landmark",
        show_in_hh: false,
        items: [
          {
            name: "centro de costos",
            description: "Centro de Costos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/centro-costos/",
            permiso: null,
          },
          {
            name: "Conciliación Bancaria",
            description: "Conciliación Bancaria",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/bancos/conciliacion-bancaria/",
            permiso: null,
          },
          {
            name: "Cuentas Bancarias",
            description: "Cuentas Bancarias",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/cuentas-bancarias/",
            permiso: null,
          },
          {
            name: "bancos",
            description: "Entidades Bancarias",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/bancos/",
            permiso: null,
          },
          {
            name: "Estado de Cuenta",
            description: "Estado de Cuenta Bancaria",
            icon: "fa fa-print",
            show_in_hh: false,
            to: "/bancos/estado-cuenta/",
            permiso: null,
          },
          {
            name: "Formas Pago",
            description: "Formas de Pago",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/cat/formas-pago/",
            permiso: null,
          },
          {
            name: "Movimientos Bancarios",
            description: "Movimientos Bancarios",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/bancos/movimiento-bancario/",
            permiso: null,
          },
        ],
      },
      {
        name: "activosfijos",
        description: "Activos Fijos",
        icon: "fas fa-building",
        show_in_hh: true,
        items: [
          {
            name: "activos-f",
            description: "Activos Fijos",
            icon: "fa fa-desktop",
            show_in_hh: true,
            to: "/af/activos/",
            permiso: null,
          },
          {
            name: "Af grupos",
            description: "AF Grupos",
            icon: "fas fa-bezier-curve",
            show_in_hh: true,
            to: "/af/grupos/",
            permiso: null,
          },
          {
            name: "Af marcas",
            description: "AF Marcas",
            icon: "fas fa-gem",
            show_in_hh: true,
            to: "/af/marca/",
            permiso: null,
          },
          {
            name: "auditoria-af",
            description: "Auditoría de AF",
            icon: "fas fa-check-square",
            show_in_hh: true,
            to: "/af/auditoria-af/",
            permiso: null,
          },
          {
            name: "af-mttos",
            description: "Mttos.",
            icon: "fas fa-car-alt",
            show_in_hh: true,
            to: "/af/mttos/",
            permiso: null,
          },
          {
            name: "af-solicitud-mtto",
            description: "Solicitud Mttos.",
            icon: "fa fa-tasks",
            show_in_hh: true,
            to: "/af/solicitud-mtto/",
            permiso: null,
          },
        ],
      },
      {
        name: "rrhh",
        description: "RRHH",
        icon: "fas fa-user-friends",
        show_in_hh: false,
        items: [
          {
            name: "buzon-sugerencias",
            description: "Buzón RRHH",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/buzon-sugerencias/",
            permiso: null,
          },
          {
            name: "constancias-laborales",
            description: "Constancias Laborales",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/constancias-laborales/",
            permiso: null,
          },
          {
            name: "contratos",
            description: "Contratos de Empleados",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/contratos/",
            permiso: null,
          },
          {
            name: "descuento-empleados",
            description: "Descuento Empleados",
            icon: "fas fa-id-card-alt",
            show_in_hh: false,
            to: "/cat/cupones-apl/nuevo",
            permiso: null,
          },
          {
            name: "encuestas-informes",
            description: "Encuestas e Informes",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/encuestas-informes/",
            permiso: null,
          },
          {
            name: "evaluacion-desempeño",
            description: "Evaluación de Desempeño",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/evaluacion-desempeño/",
            permiso: null,
          },
          {
            name: "gestiones-permisos",
            description: "Gestión de Permisos y Vacaciones",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/permisos/",
            permiso: null,
          },
          {
            name: "historial-laboral",
            description: "Historial Laboral",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/historial-empleado/",
            permiso: null,
          },
          {
            name: "horarios-turnos",
            description: "Horarios y Turnos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/horarios/",
            permiso: null,
          },
          {
            name: "incumplimientos",
            description: "Incumplimientos y Sanciones",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/sanciones/",
            permiso: null,
          },
          {
            name: "nominas-pagos",
            description: "Nóminas y Pagos",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/nomina-pagos/",
            permiso: null,
          },
          {
            name: "organigrama",
            description: "Organigrama Empresarial",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/organigrama/",
            permiso: null,
          },
          {
            name: "reclutamiento",
            description: "Reclutamiento y Selección",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/reclutamiento-seleccion/",
            permiso: null,
          },
          {
            name: "datos-empleados",
            description: "Registro de Empleados",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/rrhh/empleados/",
            permiso: null,
          },
        ],
      },
      {
        name: "Reportes",
        description: "Reportes",
        icon: "fas fa-chart-pie",
        show_in_hh: true,
        items: [
          {
            name: "asistelibros",
            description: "Asiste Libros SAT",
            icon: "fas fa-file-signature",
            show_in_hh: false,
            to: "/cxc/reportes/asistelibro/",
            permiso: null,
          },
          {
            name: "costos-por-proveedor",
            description: "Costos por Proveedor",
            icon: "fas fa-file-signature",
            show_in_hh: false,
            to: "/reporte/proveedor_costo/",
            permiso: null,
          },
          {
            name: "wms-etiqueta-referencia-factura",
            description: "Impresión de Referencia Factura",
            icon: "fas fa-print",
            show_in_hh: true,
            to: "/wms/reporte-etiqueta-referecia/",
            permiso: null,
          },
          {
            name: "impresion de habladores",
            description: "Imprimir Habladores",
            icon: "fas fa-file-signature",
            show_in_hh: false,
            to: "/cat/habladores/",
            permiso: null,
          },
          {
            name: "inconsistencias_traslados",
            description: "Inconsistencias Traslados",
            icon: "fas fa-tasks",
            show_in_hh: true,
            to: "/inventario/inconsistencias_traslados/",
            permiso: null,
          },
          {
            name: "inv-x-categoria",
            description: "Inv por Categoría",
            icon: "fas fa-file-signature",
            show_in_hh: true,
            to: "/inventario/inv-x-categoria/",
            permiso: null,
          },
          {
            name: "inv-x-proveedor",
            description: "Inv por Proveedor",
            icon: "fas fa-file-signature",
            show_in_hh: true,
            to: "/compras/reportes/inv-x-proveedor/",
            permiso: null,
          },
          {
            name: "inventario-negativo",
            description: "Inventario Sku Negativos",
            icon: "fa fa-window-minimize",
            show_in_hh: true,
            to: "/inventario/inventario-negativo/",
            permiso: null,
          },
          {
            name: "listado_facturas",
            description: "Listado de Facturas por Día",
            icon: "fas fa-file-invoice",
            show_in_hh: true,
            to: "/reporte/lista_facturas/",
            permiso: null,
          },
          {
            name: "listado_facturas_sin_recibir",
            description: "Listado de Facturas Sin Recibir",
            icon: "fas fa-file-signature",
            show_in_hh: false,
            to: "/reporte/factura_sin_recibir/",
            permiso: null,
          },
          {
            name: "listado-pedidos",
            description: "Listado de Pedidos",
            icon: "fas fa-file-signature",
            show_in_hh: false,
            to: "/cxc/reporte-pedidos/",
            permiso: null,
          },
          {
            name: "ordenes_compra_pendientes",
            description: "OC Pendientes",
            icon: "fas fa-file-signature",
            show_in_hh: true,
            to: "/compras/oc-pendientes/",
            permiso: null,
          },
          {
            name: "ordenes_compra_pendientes_x_subcategoria_proveedor",
            description: "OC Pendientes por Subcategoría y Proveedor",
            icon: "fas fa-file-signature",
            show_in_hh: true,
            to: "/compras/oc-pendientes-x-subcategoria/",
            permiso: null,
          },
          {
            name: "part-sku-categoria-tienda",
            description: "Participacion Sku Categoria Tienda",
            icon: "fas fa-file-signature",
            show_in_hh: false,
            to: "/inventario/part-sku-categoria-tienda/",
            permiso: null,
          },
          {
            name: "precios actuales por dia",
            description: "Precios Actuales por Día",
            icon: "fas fa-file-signature",
            show_in_hh: false,
            to: "/cat/precios-actuales-dia/",
            permiso: null,
          },
          {
            name: "precios_proveedor",
            description: "Precios por Proveedor",
            icon: "fas fa-file-signature",
            show_in_hh: true,
            to: "/compras/precios_proveedor",
            permiso: null,
          },
        ],
      },
      {
        name: 'conta',
        description: "Contabilidad",
        icon: "fas fa-balance-scale",
        show_in_hh: false,
        items: [
          {
            name: "conta-rpt-balance",
            description: "Balance General",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/conta/reportes/balance-general/",
            permiso: null,
          },
          {
            name: "con-cuentas-contables",
            description: "Cuentas Contables",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/con/cuentas-contables/",
            permiso: "conta.view_cuentacontable",
          },
          {
            name: "conta-rpt-diario",
            description: "Diario Contable",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/conta/reportes/diario-contable/",
            permiso: null,
          },
          {
            name: "estado_de_resultados",
            description: "Estado de resultados",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/conta/reportes/estados-resultados/",
            permiso: null,
          },
          {
            name: "conta-rpt-mayor",
            description: "Mayor Contable",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/conta/reportes/mayor-contable/",
            permiso: null,
          },
          {
            name: "con-polizas-contables",
            description: "Pólizas Contables",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/con/polizas-contables/",
            permiso: "conta.view_polizae",
          },
          {
            name: "con-tipo-poliza",
            description: "Tipos de Pólizas",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/con/tipo-poliza/",
            permiso: 'conta.view_tipopoliza',
          },
          {
            name: "conta-traslados-polizas",
            description: "Traslados de Pólizas",
            icon: "os-icon os-icon-layout",
            show_in_hh: false,
            to: "/conta/traslados/",
            permiso: null,
          },
        ],
      },
      {
        name: "utilidades",
        description: "Utilidades",
        icon: "fas fa-pencil-ruler",
        show_in_hh: true,
        items: [
          {
            name: "req_analisis",
            description: "Análisis de Requerimientos",
            icon: "fas fa-chart-area",
            show_in_hh: true,
            to: "/inventario/requerimiento-analisis/",
            permiso: null,
          },
          {
            name: "req_analisis_resumido",
            description: "Análisis de Requerimientos Resumido",
            icon: "fas fa-chart-bar",
            show_in_hh: true,
            to: "/inventario/requerimiento-analisis-resumido/",
            permiso: null,
          },
          // {
          //   name: "tarea_usuario",
          //   description: "Asignar Tarea Usuario",
          //   icon: "fas fa-cog",
          //   show_in_hh: true,
          //   to: "/wms/tarea-usuario/",
          //   permiso: null,
          // },
          {
            name: "tarea_usuario_2",
            description: "Asignar Categorias y Subcategorias a Usuario",
            icon: "fas fa-cog",
            show_in_hh: true,
            to: "/wms/categoria-usuario/",
            permiso: null,
          },
          {
            name: "autorizar-recepcion",
            description: "Autorizar Recepción",
            icon: "fas fa-marker",
            show_in_hh: true,
            to: "/wms/recepcion-autorizar/",
            permiso: null,
          },
          {
            name: "entradas_mercancia",
            description: "Entradas de Mercancía",
            icon: "fas fa-file-alt",
            show_in_hh: true,
            to: "/compras/factura/",
            permiso: null,
          },
          {
            name: "etiquetas_personalizadas",
            description: "Etiquetas Personalizadas",
            icon: "fas fa-edit",
            show_in_hh: true,
            to: "/cat/rpt-etiquetas-custom/",
            permiso: null,
          },
          {
            name: "tarima-abrir",
            description: "Opciones de Tarima",
            icon: "fas fa-cog",
            show_in_hh: true,
            to: "/wms/tarima-abrir/",
            permiso: null,
          },
          {
            name: "tarimas_traslados",
            description: "Resumen Detallado de Tarimas.",
            icon: "fa fa-tasks",
            show_in_hh: true,
            to: "/inventario/tarima/",
            permiso: null,
          },
          {
            name: "tareas_manuales",
            description: "Tareas Manuales",
            icon: "fas fa-cog",
            show_in_hh: true,
            to: "/wms/tareas-manuales/",
            permiso: null,
          },
          {
            name: "qr_generador",
            description: "Generador QR",
            icon: "fas fa-qr",
            show_in_hh: true,
            to: "/generador-qr/",
            permiso: null,
          },
        ]
      },
    ],

  },
  mutations: {
    SET_LAYOUT(state, payload) {
      console.log(payload)
      state.layout = payload;
    },
    SET_MODULE(state, payload) {
      localStorage.setItem("module", payload);
      state.module = payload;
    },
    REFRESCAR_MENU(state, payload) {
      console.log(state);
      console.log(payload);
    },
  },
  getters: {
    layout(state) {
      /*let tipo_usuario = localStorage.getItem('tipo_usuario')
      const hhusers = [
        "PICKEADOR",
        "REVISOR_ESTACION",
        "BODEGUERO",
        "PASILLO",
        "USUARIO_CEDIS",
      ];
      if (hhusers.includes(tipo_usuario)) {
        const isMobile = navigator.userAgentData.mobile;
        if (isMobile) {
          state.layout = "hh-layout";
        }else {
          state.layout = "app-layout";
        }
      }*/
      const isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))

      if (isMobile) {
        if (localStorage.getItem('token')) {
          state.layout = "hh-layout";
        } else {
          state.layout = "clean-layout";
        }
      } else {

      }
      return state.layout;
    },
    module(state) {
      let modulo = localStorage.getItem("module");
      if (modulo) {
        if (modulo !== state.module) {
          state.module = modulo;
          return modulo;
        }
      }
      return state.module;
    },
    modules(state) {
      return state.modules;
    },
  },
});
